"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.raiseClick = raiseClick;
var getDocument_1 = require("./getDocument");
/** Raises a click event.
 * @deprecated Moved to `FocusZone` component since it was the only place internally using this function.
 */
function raiseClick(target, doc) {
    var theDoc = doc !== null && doc !== void 0 ? doc : (0, getDocument_1.getDocument)();
    var event = createNewEvent('MouseEvents', theDoc);
    // eslint-disable-next-line @typescript-eslint/no-deprecated
    event.initEvent('click', true, true);
    target.dispatchEvent(event);
}
function createNewEvent(eventName, doc) {
    var event;
    if (typeof Event === 'function') {
        // Chrome, Opera, Firefox
        event = new Event(eventName);
    }
    else {
        // IE
        event = doc.createEvent('Event');
        // eslint-disable-next-line @typescript-eslint/no-deprecated
        event.initEvent(eventName, true, true);
    }
    return event;
}
//# sourceMappingURL=raiseClick.js.map